import Youtube from "assets/img/youtube.webp";

const message = (
  <div>
    <p className="text-md text-left md:mt-6 mt-3 mx-auto text-neutral-500 ">
      Sugerencias para la creación de terceros:
    </p>
    <br />
    <div className="text-md px-6">
      <ol className="list-disc text-neutral-500">
        <li>Se recomienda crear los clientes en mayúsculas.</li>
        <li>
          La cédula / NIT / Pasaporte, debe ingresarse sin puntos, sin comas y
          sin dígito de verificación.
        </li>
        <li>El correo electrónico debe ingresarse en minúsculas.</li>
        <li>
          Use la barra de busqueda para verificar que no exista antes el
          tercero.
        </li>
        <li>
          Si el tercero ya existe, el sistema no permitará crearlo 2 veces.
        </li>
      </ol>
    </div>
  </div>
);

const message2 = (
  <div>
    <p className="text-md text-left md:mt-6 mt-3 mx-auto text-neutral-500">
      En nuestros canales podrá encontrar guías y tutoriales adicionales para la
      creación de terceros.
    </p>
    <br />
    <a href="https://www.youtube.com/@presik_oficial" className="text-center">
      Más guías en Presik Oficial
      <img className="rounded-2xl w-1/2 md:w-1/3 px-2 pt-2" src={Youtube} />
    </a>
  </div>
);

export { message, message2 };
